import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchVehicle } from './vehicleAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk to fetch data with filters
export const fetchVehicleDataWithFilters = createAsyncThunk(
  'vehicle/fetchVehicleDataWithFilters',
  async ({ filter = {}, options = {} }) => {    
    const response = await fetchVehicle({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchVehicleDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchVehicleDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchVehicleDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectVehicleData = (state) => state.vehicle.data;
export const selectVehicleStatus = (state) => state.vehicle.status;
export const selectVehicleError = (state) => state.vehicle.error;

export default vehicleSlice.reducer;
